<template>
    <el-card>
        <div>{{ newCardParams.id ? `编辑卡片: ${newCardParams.id}` : "新增卡片" }}
            <CopyButton v-if="newCardParams.id" :text="newCardParams.id" />
        </div>
        <el-divider />
        <el-form :model="newCardParams" label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="名称" prop="name" required>
                        <el-input :disabled="!!newCardParams.id" v-model="newCardParams.name" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="类型(单选)" prop="type" required>
                        <el-radio-group v-model="newCardParams.type" fill="#e6a23c" size="small">
                            <el-radio-button v-for="key in Object.keys(CARD_TYPE)" :key="key" :label="CARD_TYPE[key]"
                                :value="key" />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="描述" prop="desc">
                        <el-input v-model="newCardParams.desc" type="textarea" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="图片" prop="image" required>
                        <SingleImageUploader v-if="!newCardParams.id" v-model="newCardParams.image">
                        </SingleImageUploader>
                        <el-image v-else :src="newCardParams.image" fit="cover"
                            style="width: 100%; max-width: 180px; height: 240px; border-radius: 8px;" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Video" prop="video">
                        <SingleImageUploader v-model="newCardParams.video"></SingleImageUploader>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item v-if="newCardParams.type === 'card'" label="分类(可多选)" prop="categoryIds">
                        <el-checkbox-group v-model="newCardParams.categoryIds" fill="#409eff" size="small">
                            <el-checkbox-button v-for="item in cardCategoryStore.categories" :key="item.id"
                                :label="item.name" :value="item.id" />
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item v-if="newCardParams.type === 'fragment'" label="碎片(单选)" prop="categoryIds">
                        <el-radio-group v-model="newCardParams.fragmentId" fill="#409eff" size="small">
                            <el-radio-button v-for="item in cardFragmentStore.fragments" :key="item.id"
                                :label="item.name" :value="item.id" />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item v-if="newCardParams.type === 'card'" label="标签(可多选)" prop="tagIds">
                        <el-checkbox-group v-model="newCardParams.tagIds" fill="#67c23a" size="small">
                            <el-checkbox-button v-for="item in cardTagStore.tags" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item v-if="newCardParams.type === 'card'" label="稀有度(单选)" prop="rarity">
                        <el-radio-group v-model="newCardParams.rarity" fill="#e6a23c" size="small">
                            <el-radio-button v-for="r in rarities" :key="r" :label="r" :value="r" />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="newCardParams.type === 'card' ? '价值' : '数量'" prop="value">
                        <el-input v-model="newCardParams.value" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="允许兑换积分" prop="allowExchange">
                        <el-switch v-model="newCardParams.allowExchange" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="允许邮寄提现" prop="allowShip">
                        <el-switch v-model="newCardParams.allowShip" />
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <template #footer>
            <el-button @click="cancel">取消</el-button>
            <el-button v-if="!newCardParams.id" @click="resetAll">清空</el-button>
            <el-button v-if="!newCardParams.id" v-loading="newCardParams.loading" type="primary"
                @click="submitAddCard">新增</el-button>
            <el-button v-if="!!newCardParams.id" v-loading="newCardParams.loading" type="primary"
                @click="submitEditCard">保存</el-button>

        </template>
    </el-card>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { apiCall } from "@/utils/api";
import { CARD_TYPE } from "@/utils/constant";
import { useCardCategoryStore } from "@/stores/card/category";
import { useCardTagStore } from "@/stores/card/tag";
import { useCardFragmentStore } from "@/stores/card/fragment";

const cardCategoryStore = useCardCategoryStore();
const cardTagStore = useCardTagStore();
const cardFragmentStore = useCardFragmentStore();

const route = useRoute();
const router = useRouter();

const loading = ref(false);
const rarities = ref([]);

const newCardParams = reactive({
    id: "",
    name: "",
    type: "card",
    desc: "",
    image: "",
    video: "",
    categoryIds: [],
    tagIds: [],
    fragmentId: "",
    rarity: "",
    value: 0,
    allowExchange: true,
    allowShip: true,
});

watch(
    () => newCardParams.categoryIds,
    (newIds) => {
        rarities.value = cardCategoryStore.cardRarities(newIds);
    }
);

async function loadData(id) {
    loading.value = true;
    const response = await apiCall("card.getCard", { id });
    if (!response) {
        loading.value = false;
        return false;
    }

    response.allowExchange = response.allowExchange === 1;
    response.allowShip = response.allowShip === 1;

    Object.keys(newCardParams).forEach(key => {
        newCardParams[key] = response[key];
    });
    if (newCardParams.type === "fragment") {
        newCardParams.fragmentId = newCardParams.categoryIds[0] || "";
    }

    loading.value = false;
}

async function resetAll() {
    newCardParams.loading = true;

    // newCardParams.id = "";
    newCardParams.name = "";
    newCardParams.type = "card";
    newCardParams.desc = "";
    newCardParams.image = "";
    newCardParams.video = "";
    newCardParams.categoryIds = [];
    newCardParams.tagIds = [];
    newCardParams.fragmentId = "";
    newCardParams.rarity = "";
    newCardParams.value = 0;
    newCardParams.allowExchange = true;
    newCardParams.allowShip = true;

    newCardParams.loading = false;
}

function checkParamsBeforeSumbit() {
    if (newCardParams.type !== "card") {
        newCardParams.categoryIds = [];
        newCardParams.tagIds = [];
        newCardParams.rarity = "";
        if (newCardParams.type === "fragment" && newCardParams.fragmentId) {
            newCardParams.categoryIds.push(newCardParams.fragmentId);
        }
    }
}

async function submitAddCard() {
    checkParamsBeforeSumbit();
    newCardParams.loading = true;

    const response = await apiCall("card.addCard", {
        name: newCardParams.name,
        type: newCardParams.type,
        desc: newCardParams.desc,
        image: newCardParams.image,
        video: newCardParams.video || "",
        categoryIds: newCardParams.categoryIds || [],
        tagIds: newCardParams.tagIds || [],
        rarity: newCardParams.rarity || "",
        value: newCardParams.value || 0,
        allowExchange: !!newCardParams.allowExchange,
        allowShip: !!newCardParams.allowShip,
    });

    newCardParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessageBox.alert("可在此基础上修改部分配置继续增加卡片，若要清空数据重新配置，请点击底部清空按钮！", "增加卡片成功!", {
        confirmButtonText: 'OK',
        callback: (action) => { },
    });

    return true;
}

async function submitEditCard() {
    checkParamsBeforeSumbit();
    newCardParams.loading = true;

    const response = await apiCall("card.modifyCard", {
        id: newCardParams.id,
        // name: newCardParams.name,
        // type: newCardParams.type,
        desc: newCardParams.desc,
        // image: newCardParams.image,
        video: newCardParams.video || "",
        categoryIds: newCardParams.categoryIds || [],
        tagIds: newCardParams.tagIds || [],
        rarity: newCardParams.rarity || "",
        value: newCardParams.value || 0,
        allowExchange: !!newCardParams.allowExchange,
        allowShip: !!newCardParams.allowShip,
    });

    newCardParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success("修改卡片成功");
    return router.go(-1);
}

function cancel() {
    return router.go(-1);
}

onMounted(async () => {
    await cardCategoryStore.getAll();
    await cardTagStore.getAll();
    await cardFragmentStore.getAll();

    if (route.params.id) {
        await loadData(route.params.id);
    }
});
</script>

<style scoped>
.basic-part .el-row {
    margin-bottom: 10px;
}
</style>
